import React, { Component} from "react";
import { BallTriangle } from "react-loader-spinner";
import QRCode from "react-qr-code";
import PersonalInformationStep from "./PersonalInformationStep";
import { Button, Container, Form } from "react-bootstrap";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";



export type MaenadaAuthenticationQRProps = {
  onAuthRequestRetrieved: () => void;
  mandatoryOnly?: boolean;
  token?: string;
  onSignInComplete: (payload: AuthorizationResponsePayload ) => void;
};

export interface AuthenticationQRState {
  //authRequestURIResponse?: GenerateAuthRequestURIResponse;
  uri?: string;
  originalUri?: string;
  claims?: any;
}

export default class MaenadaAuthenticationQR extends Component<MaenadaAuthenticationQRProps> {
  public state: AuthenticationQRState = {};

  private registerStateSent: boolean = false;
  private refreshTimerHandle?: NodeJS.Timeout;
  private qrExpirationMs: number = 0;
  private timedOutRequestMappings: Set<AuthenticationQRState> =
    new Set<AuthenticationQRState>();
  private _isMounted: boolean = false;

  private readonly definitionId =
    process.env.REACT_APP_PRESENTATION_DEF_ID || "sphereon";

  componentDidMount() {
    this.qrExpirationMs =
      parseInt(process.env.REACT_APP_QR_CODE_EXPIRES_AFTER_SEC ?? 1200) * 1000;
    // actually since the QR points to a JWT it has its own expiration value as well.

    if (this.props.mandatoryOnly){
      this.loadMandatoryQRCode();
    }
    else{
      this.loadAllQRCode();
    }
    this._isMounted = true;
  }

  async getToken(){
    let maenadaUrlTransaction= "https://maenada-oid4vc-issuer.test.veridos-egov.com/oauth2/token";

    let formData = new FormData();
    formData.append('grant_type', 'client_credentials');

    let response = await fetch(maenadaUrlTransaction, {
      method: "POST",
      mode: 'cors',
      headers: {
        "Accept": "application/json, text/plain, */*",
        "Authorization": "Basic dmVyaWZpZXItdWktY2xpZW50OnNlY3JldDI="
      },
      body: formData,
    });
    let token = await response.json();
    //console.log(transactionInfo);
    return token.access_token;
  }

  async getTransaction(token: string){
    let initTransaction = {
      "presentationRequest": {
          "nonce": "67cOfb9c-eb45-44d0-b26c-89afa3634481",
          "id": "pid-or-photo-id-mandatory-alternative"
      },
      "metadata": {
          "requestObjectUsage": "",
          "urlScheme": "openid4vp://"
      }
    };
    let maenadaUrlTransaction= "https://maenada-oid4vc-verifier.test.veridos-egov.com/openid4vp/transactions";

    let response = await fetch(maenadaUrlTransaction, {
      method: "POST",
      mode: 'cors',
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token
      },
      body: JSON.stringify(initTransaction),
    });
    let transactionInfo = await response.json();
    //console.log(transactionInfo);
    this.setState({uri: transactionInfo.urlRepresentation, originalUri: transactionInfo.urlRepresentation});
    this.waitForTransaction(token, transactionInfo.expandedRepresentation.transaction_id)
    return transactionInfo.expandedRepresentation.transaction_id;
  }

  async waitForTransaction(token: string, transactionId: string){
    const params = new URLSearchParams(document.location.search);
    const transactionIdParam = params.get('transactionId');
    transactionId = (transactionIdParam != null && transactionIdParam != "") ? transactionIdParam : transactionId;
    let maenadaUrlTransaction= "https://maenada-oid4vc-verifier.test.veridos-egov.com/openid4vp/transactions/" + transactionId;

    let response = await fetch(maenadaUrlTransaction, {
      method: "GET",
      mode: 'cors',
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token
      }
    });
    let transactionInfo = await response.json();
    //console.log(transactionInfo);
    if (transactionInfo.status != "VERIFIED"){
      setTimeout(() => this.waitForTransaction(token, transactionId), 3000);
    } else {
      this.setState({claims: transactionInfo.claims});
       return this.props.onSignInComplete(
          {
            vp_token: 'eyJraWQiOiJtbmQtb2lkNHZjaS1zZWxmLXNpZ25lZCIsInR5cCI6ImRjK3NkLWp3dCIsImFsZyI6IkVTMjU2In0.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.K8WCXnLAkOA3T1nl6ShUOZ6eR_G_hIevI4hKKM06_NhC8HikDLJVrSZ_c_RzVl3MizqHcPrMcs_HN4DxrTGalQ~WyJsZmVnNm4tYlloSFVCX3hqa2xYeWR3IiwibG9jYWxpdHkiLCJMZWlwemlnIl0~WyJNWkh4dnJ0elViOThHOE9SbHNQVkJ3IiwiYmlydGhkYXRlIiwiMTUtMDQtMTk5MyJd~WyJseGtqaGNWUVdOOHRodVFIdGtwM1pBIiwiZm9ybWF0dGVkIiwiMTIzIFZpYSBBcHBpYSAxMTEsIFJvbWUgMDAxMDAsIExhemlvLCBJVCJd~WyJzTk5KTVFRTlNxRjhKa2ZPbWZXQlpnIiwiaXNzdWluZ19jb3VudHJ5IiwiSVQiXQ~WyJpdk9qeDNSQkw4WVNaQ2RxOW1UYzh3IiwiaXNzdWluZ19hdXRob3JpdHkiLCJJVCJd~WyJWM0JoVDF4MkMwdTFmMlBfUm9yQWdnIiwiZ2l2ZW5fbmFtZSIsIkplYW4iXQ~WyJmLXBGQS1SZzVrc0poT0wxVUFFZWlBIiwiZmFtaWx5X25hbWUiLCJEdXBvbnQiXQ~WyJzYXEzbFcybEdwS204S0JlNkhkbVBRIiwiMTgiLHRydWVd~eyJ0eXAiOiJrYitqd3QiLCJhbGciOiJFZERTQSJ9.eyJzZF9oYXNoIjoiNDlOS0ZidEJJV3lpX0VUQXplaEpSY2hkSFNoTGduREdBczRmanl4OWhYYyIsImF1ZCI6Ing1MDlfc2FuX2RuczptYWVuYWRhLW9pZDR2Yy12ZXJpZmllci5kaXAudmVyaWRvcy1lZ292LmNvbSIsIm5vbmNlIjoiWTFIdDkzSnVrNUZ6Y3J5OFdIR3lub2lfSTlXN1RGYjRyc1hSelFvd1hDNk1VS2J5MVAzeC1lMWdTOHBQVmhFeWwyc2d3ZDRucDROSmo5cVZNX3QtMWUiLCJpYXQiOjE3NTU4NTkyMDF9.7ANtARruZuSl3YJL4R5lrkFOg_2bA99teHgHBxaUs17v4me-j9pCOvXc8HUVUYGJ8-LRudrUIM1kQOwW1it6Ag',
            state: 'oqP6vPIymacJN7TZNYsjhymirg_R8S69JeBsKROzbVLyBs4OJMWGEPWxFcOYsxLg0pCHvHIo8PgP2SEXN-9jOw',
            presentation_submission: {"definition_id":"pid_mandatory_attributes_only","id":"pid_mandatory_attributes_only_submission","descriptor_map":[{"id":"pid_credential","path":"$","format":"dc+sd-jwt"}]},
            claims: this.state.claims
          } as AuthorizationResponsePayload,
        );
    }
  }

  async loadMandatoryQRCode(){
    let token = await this.getToken();
    await this.getTransaction(token);
  }

  async loadAllQRCode(){
    let token = await this.getToken();
    await this.getTransaction(token);
  }


  componentWillUnmount() {
    if (this.refreshTimerHandle) {
      clearTimeout(this.refreshTimerHandle);
    }
    this.setState({});
    this._isMounted = false;
  }

  render() {
    // Show the loader until we have details on which parameters to load into the QR code
    // if (this.state.claims != null){
    //   return (
    //   <div>
    //     <PersonalInformationStep claims={this.state.claims} />
    //   </div>
    //   );
    // }
    // else 
    return this.state.uri? (
      <div>
         <Container>
          {/* <span className="span-2">In order to test with another schema</span>
          <Form.Control
                placeholder="Schema"
                aria-label="Schema"
                aria-describedby="basic-addon1"
                onChange={(item) => {
                  this.setState({uri: this.state.originalUri?.replace("haip://", item.currentTarget.value + "://")})
                }}
              />
          <br></br> */}
          <QRCode
                value={this.state.uri}
              />
        </Container>
        
      </div>
    ) : (
      <BallTriangle color="#352575" height="100" width="100" />
    );
  }
}
